// extracted by mini-css-extract-plugin
export default {"hoverContent":"Favorites-module__hoverContent--Ip68X","menuButton":"Favorites-module__menuButton--cXFol","animatedBackground":"Favorites-module__animatedBackground--UbBQX"};